export default function fractionalPartnerFeesTransformer(response) {
  const data = response?.data ?? response
  const totalRaw = data?.partnerFee

  const partnerFeeTotal = +totalRaw
  const taxTotal = +data?.taxAmount

  return { partnerFeeTotal, taxTotal }
}
